import { createTheme } from '@mui/material';
import { red } from '@mui/material/colors';

export default createTheme({
  palette: {
    primary: {
      main: red[500],
    },
    secondary: {
      main: '#11cb5f',
    },
  },
});
